module.exports = __webpack_public_path__ + "img/icon-kitchen.8a553b27.svg";